<template>
  <div >
    <line-chart :chart-data="datacollection" :options="dataOptions"></line-chart>    
  </div>
</template>

<script>
  import LineChart from './LineChart.js'

    export default {
        name: "EloChart",
        components: {
            LineChart
        },
        data () {
            return {
                datacollection: {},
                dataOptions: {}
            }
        },
        props: {
            chartData: {
                type: Array,
                default(){
                    return []
                }
            },
            labels: {
                type: Array,
                default(){
                    return []
                }
            }
        },
        mounted () {
            this.fillData()
        },
        methods: {
            fillData () {
                this.datacollection = {
                    labels: this.labels,
                    datasets: [
                        {
                            label: 'Elo progress', 
                            fill: false,                           
                            data: this.chartData,
                            borderColor: "#e63212",
                            pointRadius: 1,
                            pointHitRadius: 3,
                            borderWidth: 2
                        }
                    ]
                }
                this.dataOptions = {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            afterTickToLabelConversion: function(data){


                                var xLabels = data.ticks;

                                xLabels.forEach(function (labels, i) {
                                    if (i % 10 == 1){
                                        xLabels[i] = '';
                                    }
                                });
                            } 
                        }]   
                    }
                }
            },
        }
    }
</script>

<style>  
</style>
